
import * as React from 'react'
import img_eye from './../../Icone/eyes_security.png'
import img_security from './../../Icone/security_approved.png'
import img_terms from './../../Icone/Accept_terms.png'
import img_subs from './../../Icone/subscribe.png'
import img_bweb from './../../Icone/bad_website.png'
import img_pvs from './../../Icone/privasee_inc.png'
import Header from '../structure/Header/Header'
import ApiCall from '../../components/ApiCall/ApiCall'
import Footer from '../structure/Footer/Footer'
import SearchBar from '../../components/Search/SearchCgu'
require('./accueil.css')
require('./header.css')

/*
	This class is the home page and use SearchCgu as search bar to find site
*/
interface AccueilState {
	error:boolean
	numberofWebsite:any
    numberofReseachThisWebb: any
}

interface AccueilProps {
}

export default class Accueil extends React.Component<AccueilProps, AccueilState> {
	private api = new ApiCall()

	constructor(props: AccueilProps){
		super(props)
		this.state = {
			error : false,
			numberofWebsite:0,
            numberofReseachThisWebb: 0,
        };
	}


	componentDidMount = async () => {
        const request = await this.api.ApiCall("metrics", "GET", {}, localStorage.getItem('AccessToken'))

		if(request.status === 200)
		{
			console.log(request.data)
			this.setState({
				numberofWebsite : request.data.numberOfWebsite,
                numberofReseachThisWebb : request.data.numberOfReseachThisWebb,
			})
		} else if(request.status !== 200) {
			console.log("ALERTE");
		}
	}

	render() {
		return (
			<>	
				<div id="Top-Acc">
					<div id="particles-js">
						<Header/>
						<div className="hero-wrap js-fullheight">
							<div className="overlay"></div>
							<div className="container">
								<div className="row no-gutters slider-text align-items-center justify-content-center" data-scrollax-parent="true">
									<div id="border-search" className="col-md-6 ftco-animate text-center fadeInUp ftco-animated" data-scrollax=" properties: { translateY: '70%' }">
										<img id="logo-ac" alt="logo" src={img_pvs} width="25%"></img>
										<br></br>
										<br></br>
										<h1 className="mb-4" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
											<strong>PrivaSee</strong>
											<br></br>
											<br></br>
											Analyser un site internet
											<br></br>
											<br></br>
											<SearchBar/>
										</h1>
									</div>
								</div>
							</div>
						</div>
					</div>
					<section>
						<div className="container">
							<h2 id="desc_acc_titleprivasee"><b>Avec PrivaSee</b></h2>
							<br></br>
							<br></br>
							<br></br>
										<br></br>
							<div id="description_acc">
								<div id="pair">
									<img alt="eye" src={img_eye} width="40%" height="40%"></img>
									<div id="pair_text">
										<p>Nous vous proposons d'avoir un <b>regard</b> sur les</p>
										<p><b>Conditions Générales d'Utilisations</b> des sites internet.</p>
									</div>
								</div>
								<div id="impair">
									<img alt="security" src={img_security} width="40%" height="40%"></img>
									<div id="impair_text">
										<p>Afin que vous puissiez être au <b>courant</b></p><p>et <b>protégé</b> sur ces sites</p>
									</div>
								</div>
								<div id="pair">
									<img alt="bweb" src={img_bweb} width="50%" height="40%"></img>
									<div id="pair_text">
										<p>Et que vos <b>informations personnelles</b></p><p> ne soient pas utilisées à votre insu</p>
									</div>
								</div>
								<div id="impair">
										<img alt="terms" src={img_terms} width="40%" height="40%"></img>
									<div id="impair_text">
										<p>Nous nous engageons à ce que ces <b>informations</b> </p><p>vous soient <b>accessible</b> et <b>compréhensible</b> facilement</p>
									</div>
								</div>
								<div id="pair">
										<img alt="subs" src={img_subs} width="40%" height="40%"></img>
									<div id="pair_text">
										<p>Nous proposons également un <b>service de suppression</b></p><p> de données par <b>mandat électronique</b></p>
									</div>
								</div>
							</div>
						</div>
					</section>
					<section id="last-section">
						<div className="container">
							<div className="row justify-content-center mb-5">
								<div className="col-md-7 text-center heading-section heading-section-white ftco-animate fadeInUp ftco-animated">
										<h2>ACTUELLEMENT...</h2>
								</div>
							</div>
							<div className="last-section-text">
								<div className="col-md-6 col-lg-4 d-flex justify-content-center counter-wrap ftco-animate fadeInUp ftco-animated last-section-text-first">
									<div className="block-18 text-center">
										<div className="text">
											<strong className="number" data-number="1642">
												{this.state.numberofWebsite}
											</strong>
											<span>
											Nombre de sites que nous avons répertorié
											</span>
										</div>
									</div>
								</div>
								<div className="col-md-6 col-lg-4 d-flex justify-content-center counter-wrap ftco-animate fadeInUp ftco-animated">
									<div className="block-18 text-center">
										<div className="text">
										</div>
									</div>
								</div>
								<div className="col-md-6 col-lg-4 d-flex justify-content-center counter-wrap ftco-animate fadeInUp ftco-animated">
									<div className="block-18 text-center">
										<div className="text">
											<strong className="number" data-number="33762">
												{this.state.numberofReseachThisWebb}
											</strong>
											<span>
											Sites qui ont été recherché cette semaine
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
				<Footer/>
				</div>
			</>
		);
	}

}